var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRomanaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.511963V17.488C2.505 16.252 0 12.919 0 8.99996C0 5.08096 2.505 1.74796 6 0.511963Z",
    fill: "#41479B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.512V17.488C11.062 17.82 10.052 18 9 18C7.948 18 6.938 17.82 6 17.488V0.512C6.938 0.18 7.948 0 9 0C10.052 0 11.062 0.18 12 0.512Z",
    fill: "#FFE15A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.99996C18 12.919 15.495 16.252 12 17.488V0.511963C15.495 1.74796 18 5.08096 18 8.99996Z",
    fill: "#FF4B55"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRomanaIcon);
export default __webpack_public_path__ + "static/media/RomanaIcon.2df8433f3cba9be3301934499c71b338.svg";
export { ForwardRef as ReactComponent };